import script from "./Foot.vue?vue&type=script&setup=true&lang=ts"
export * from "./Foot.vue?vue&type=script&setup=true&lang=ts"

import "./Foot.vue?vue&type=style&index=0&id=283e4c53&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-283e4c53"]])

export default __exports__